<template>
  <div class="col-12">
    <div class="col-12 mt-3">
      <div class="row filter-row-saved">
        <div
          class="col-12 mb-4 col-lg-3"
          :class="isMobile && 'bg-gray rounded py-3'"
        >
          <span>{{ item.name }}</span>
          <span
            v-if="isMobile && item.required"
            class="font-16 ml-2 text-muted"
          >
            *
          </span>
        </div>
        <div class="col-12 mb-4 col-lg-3" :class="isMobile && 'px-0'">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              :clearable="false"
              fieldkey="id"
              fieldname="name"
              :options="options(item)"
              placeholder="Seleccione Filtro"
              :class="isMobile && 'w-100'"
              :disabled="isDisabled(item) || generationMode"
              v-model="item.model.conditional"
              :error="errors[0]"
              custom-error-msg="Este campo es requerido."
            />
          </validation-provider>
        </div>
        <div class="col-12 mb-1 mb-md-0 col-lg-4" :class="isMobile && 'px-0'">
          <validation-provider v-slot="{ errors }" rules="required">
            <component
              :is="filtersSelected(item)"
              v-bind="currentProperties(item)"
              v-model="item.model.value"
              :error="errors[0]"
              :disabled="isDisabled(item)"
              :is-disabled="isDisabled(item)"
              custom-error-msg="Este campo es requerido."
            ></component>
          </validation-provider>
        </div>
        <div
          v-if="showAddons"
          class="col-12 mb-md-0 col-lg-2 d-flex justify-content-around"
          :class="isMobile && 'px-0 w-100'"
        >
          <div class="border-left d-none d-md-flex"></div>
          <div
            class="d-flex justify-content-center align-items-center"
            :class="isMobile && 'w-100'"
          >
            <div v-if="!item.required" :class="isMobile && 'w-100'">
              <action-button
                v-if="isMobile"
                i="fas fa-times-circle"
                variant="outline-danger"
                id="btn-delete"
                text="Eliminar"
                class="my-2 w-100"
                @click="removeFilter()"
              />
              <i
                v-else
                class="fa-solid fa-xmark text-red font-24 cursor-pointer"
                aria-hidden="true"
                @click="removeFilter()"
              ></i>
            </div>
            <span v-if="!isMobile && item.required" class="font-24 text-muted">
              *
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import customDatePicker from 'custom-date-picker';
import Error from '@/components/common/Error';
import CustomInput from '@/components/common/form/CustomInput';
import { ValidationProvider } from 'vee-validate';
import rbDataType from '@/utils/constants/rbDataType.js';
import rbConditionals from '@/utils/constants/rbConditionals.js';
import ActionButton from 'ActionButton';
import Multiselect from '@quisit/multiselect';
import DatepickerRange from '@quisit/datepicker-range';
import CustomRadio from '@/components/common/CustomRadio';

export default {
  name: 'FilterRow',
  components: {
    CustomDropDown,
    customDatePicker,
    CustomInput,
    Error,
    ValidationProvider,
    ActionButton,
    Multiselect,
    DatepickerRange,
    CustomRadio,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    conditionals: {
      type: Array,
      default: () => [],
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    showAddons: {
      type: Boolean,
      default: true,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    generationMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    filtersSelected() {
      return (item) => {
        const { dataType, isMultiSelect } = item;
        if (dataType == rbDataType.Date)
          return isMultiSelect ? 'DatepickerRange' : 'customDatePicker';
        if (dataType == rbDataType.Text || dataType == rbDataType.Number)
          return 'CustomInput';
        if (dataType == rbDataType.Select) {
          return isMultiSelect ? 'Multiselect' : 'CustomDropDown';
        }
        if (dataType == rbDataType.Boolean) {
          return 'CustomRadio';
        }

        return 'CustomInput';
      };
    },
    currentProperties() {
      return (filter) => {
        if (filter.dataType == rbDataType.Text) return { maxlength: '50' };
        if (filter.dataType == rbDataType.Number) return { maskType: 'Number' };
        if (filter.dataType == rbDataType.Select) {
          return {
            options: filter.source,
            fieldkey: 'id',
            fieldname: 'name',
            placeholder: 'Seleccione',
            disabled: this.generationMode,
          };
        }
        if (filter.dataType == rbDataType.Boolean) {
          return {
            class: 'mt-2 custom-radio__extended',
            isInline: true,
            options: [
              { label: 'Activo', value: '1' },
              { label: 'Inactivo', value: '0' },
            ],
          };
        }
      };
    },
    isDisabled() {
      return (filter) => {
        if (this.readOnly) {
          return true;
        }
        if (filter.dataType === 'Date' && filter.id === 12) {
          return true;
        }

        return false;
      };
    },
    options() {
      return (filter) => {
        if (filter.dataType === rbDataType.Text) {
          return (
            this.conditionals.filter((e) =>
              [rbConditionals.Equal].includes(e.id)
            ) || []
          );
        }
        if (filter.dataType === rbDataType.Boolean) {
          this.item.model.conditional = this.conditionals.find(
            (e) => e.id === rbConditionals.Equal
          );
          return (
            this.conditionals.filter((e) =>
              [rbConditionals.Equal].includes(e.id)
            ) || []
          );
        }
        if (filter.dataType === rbDataType.Number) {
          return (
            this.conditionals.filter(
              (e) => ![rbConditionals.Contains].includes(e.id)
            ) || []
          );
        }
        if (filter.dataType === rbDataType.Select) {
          if (filter.isMultiSelect) {
            this.item.model.conditional = this.conditionals.find(
              (e) => e.id === rbConditionals.Contains
            );
            return (
              this.conditionals.filter((e) =>
                [rbConditionals.Contains].includes(e.id)
              ) || []
            );
          } else {
            this.item.model.conditional = this.conditionals.find(
              (e) => e.id === rbConditionals.Equal
            );
            return (
              this.conditionals.filter((e) =>
                [rbConditionals.Equal].includes(e.id)
              ) || []
            );
          }
        }
        if (filter.dataType === rbDataType.Date) {
          if (filter.isMultiSelect) {
            this.item.model.conditional = this.conditionals.find(
              (e) => e.id === rbConditionals.Contains
            );
            return (
              this.conditionals.filter((e) =>
                [rbConditionals.Contains].includes(e.id)
              ) || []
            );
          } else {
            return (
              this.conditionals.filter(
                (e) => e.id !== rbConditionals.Contains
              ) || []
            );
          }
        }
        return this.conditionals || [];
      };
    },
  },
  watch: {
    item: {
      immediate: true,
      handler(val) {
        if (val?.conditional?.id && val?.conditional?.name) {
          val.model.conditional = this.conditionals?.find(
            (e) => e.id === val.conditional.id
          );
        }
      },
    },
  },
  methods: {
    removeFilter() {
      this.$emit('remove', this.item);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_colors.scss';
.custom-radio__extended ::v-deep {
  input[type='radio']:checked + label.custom-control-label::before {
    color: #fffefe;
    border-color: #ff6f52;
    background-color: #ff6f52;
  }
  .custom-control-input:checked.custom-control-input:checked:disabled
    ~ .custom-control-label::before {
    color: #fff;
    border-color: #ff6f52;
    background-color: #ff6f52;
  }
}

@media only screen and (max-width: 600px) {
  .filter-row-saved {
    padding: 0.5rem;
  }

  ::v-deep div.vs__dropdown-toggle {
    padding: 0.5rem 0 !important;
  }

  ::v-deep input[type='text'] {
    height: 41px !important;
  }
}

::v-deep input[type='checkbox']:checked + label span {
  background-color: #ff6f52 !important;
}
</style>
